import type { ComponentMode, ShippingConfig } from 'types';

interface State extends ShippingConfig {
  mode: ComponentMode;
  defaultTitle: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_SHIPPING_CONFIG_AMOUNT_TYPE';
      payload: Pick<typeof initialState, 'amountType'>;
    }
  | {
      type: 'UPDATE_SHIPPING_CONFIG_AMOUNT';
      payload: Pick<typeof initialState, 'amount'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
